module.exports = __WEBPACK_EXTERNAL_MODULE_185__;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 185
// module chunks = 3 4